import { useBlogPostCategoryQuery, useBlogPostQuery } from '@/network/_queries/blog.queries';

export const useBlogPost = (cSlug: string, pSlug: string) => {
  const post = useBlogPostQuery(cSlug, pSlug);
  const search = useBlogPostCategoryQuery(cSlug);

  return { post: post.data, categoryItems: search.data?.results || [] };
};
